module.exports = __webpack_public_path__ + "img/sc.ab4767bc.svg";